import React from 'react';
import styled, { css } from 'styled-components';
import ResultCard from './ResultCard';
import DescentProfileAnimation from './DescentProfileAnimation';
import { useI18n } from '../i18n/index';
import { theme } from '../styles/theme';
import { fadeInUp, withMotion } from '../styles/animations';

const ResultsPanel = ({
  distance,
  estimated,
  glideSlope,
  startAltitude,
  endAltitude,
}) => {
  const { t } = useI18n();
  const isEmpty = !distance && !estimated;
  const hasResult = !!(distance && estimated);

  return (
    <Section aria-label={t('results.title')}>
      <SectionHeader>
        <SectionLabel>{t('results.title')}</SectionLabel>
        {isEmpty && <EmptyHint>{t('results.empty')}</EmptyHint>}
      </SectionHeader>

      <ResultsCard hasResult={hasResult ? 1 : 0}>
        <Grid>
          <ResultCard
            label={t('results.topOfDescent')}
            value={distance}
            unit={t('units.nauticalMiles')}
            testId="result-top"
            empty={!distance}
            note={distance ? t('results.approximate') : null}
          />
          <ResultCard
            label={t('results.estimatedTime')}
            value={estimated}
            unit={t('units.minutes')}
            testId="result-estimated"
            empty={!estimated}
            note={estimated ? t('results.approximate') : null}
          />
        </Grid>

        <DescentProfileAnimation
          glideSlope={glideSlope}
          startAltitude={startAltitude}
          endAltitude={endAltitude}
          hasResult={hasResult}
        />
      </ResultsCard>
    </Section>
  );
};

const Section = styled.section`
  ${withMotion(css`
    animation: ${fadeInUp} 0.45s ease both;
    animation-delay: 0.15s;
  `)}
`;

const SectionHeader = styled.div`
  display: flex;
  align-items: baseline;
  gap: ${theme.spacing.md};
  margin-bottom: ${theme.spacing.md};
  flex-wrap: wrap;
`;

const SectionLabel = styled.h2`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: ${theme.colors.textMuted};
`;

const EmptyHint = styled.p`
  font-size: 11px;
  color: ${theme.colors.textMuted};
  font-style: italic;
`;

const ResultsCard = styled.div`
  background: ${theme.colors.resultBg};
  border: 1px solid ${({ hasResult }) =>
    hasResult ? theme.colors.resultBorder : theme.colors.borderSoft};
  border-radius: ${theme.radius.xl};
  padding: ${theme.spacing.lg} ${theme.spacing.xl};
  transition: border-color 0.3s ease;

  @media (max-width: ${theme.breakpoints.mobile}) {
    padding: ${theme.spacing.md};
    border-radius: ${theme.radius.lg};
  }
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${theme.spacing.md};

  @media (max-width: ${theme.breakpoints.mobile}) {
    grid-template-columns: 1fr;
  }
`;

export default ResultsPanel;
